module.exports = __webpack_public_path__ + "img/mystery_c@2x.9dfecde9.png";